<div
	class="flex flex-col px-1 h-full"
	[ngClass]="loading ? 'justify-center' : ''"
>
	<div
		[ngClass]="loading ? 'flex' : 'hidden'"
		class="text-center flex-col place-items-center gap-3"
	>
		<img class="loading-gif" src="/assets/images/auth/creating-business.gif" />
		<h4>Creating {{ companyName?.value }}...</h4>
		<p class="text-grey text-sm">This will only take a few moments!</p>
	</div>
	<form
		[formGroup]="authForm"
		(ngSubmit)="onSubmitForm()"
		class="flex-1 flex flex-col justify-between"
		*ngIf="!loading"
	>
		<div class="flex flex-col flex-auto text-sm">
			<div class="text-2xl mb-8 font-bold mt-4">Business Information</div>
			<app-input
				[submitted]="form.submitted"
				label="Business Name"
				placeholder="Enter your business name"
				[formControlName]="BUSINESS_INFORMATION.NAME"
				(onFocus)="updateLandscapePosition(landscapePositions.SIXTH)"
				class="flex-initial"
				[disabled]="loading"
				[required]="true"
			></app-input>

			<app-address
				name="Business address"
				class="mt-4 flex-initial"
				[enableCountrySelect]="true"
				[formControlName]="BUSINESS_INFORMATION.BUSINESS_ADDRESS"
				[required]="true"
				[submitted]="!!form.submitted"
				[address]="formData?.businessAddress"
				[disabled]="loading"
				(onFocus)="updateLandscapePosition(landscapePositions.SEVENTH)"
			>
			</app-address>

			<ng-container
				*ngIf="
					(signUpRequest$ | async)?.newMatterDocumentFlows !==
					MatterDocumentFlows.WORD
				"
			>
				<div class="flex justify-between mt-5 mb-2">
					<div class="flex">
						<p class="text-sm tooltip-wrapper">Letterhead</p>
						<app-icon
							class="mx-2"
							[icon]="icon.INFO"
							matTooltip="For best quality letterhead use PDF format"
						></app-icon>
					</div>
					<p class="text-xs text-grey">Optional</p>
				</div>

				<atomic-dropzone
					*ngIf="!letterHeadFile"
					class="text-center"
					size="compact"
					(fileChanged)="onLetterHeadFileSelected($event)"
					[formControlName]="BUSINESS_INFORMATION.LETTERHEAD_FILE"
					[ngModel]="formData?.letterheadFile"
				></atomic-dropzone>
			</ng-container>

			<app-internet-file
				class="mb-16"
				actionType="upload"
				*ngIf="letterHeadFile"
				[documentName]="letterHeadFile?.name"
				[date]="date.toString()"
				(onAction)="removeLetterHeadFile()"
				[fileSize]="fileSize"
			>
			</app-internet-file>

			<p *ngIf="showError" class="text-red mt-2">
				File size must be less than {{ maxFileSize | fileSize: 'MB' }}
			</p>
		</div>
		<div class="flex justify-end items-end gap-4">
			<ui-button
				(click)="_onBack()"
				preset="LOW_EMPHASIS"
				label="Back"
				icon="chevron-left"
			></ui-button>
			<ui-button
				type="submit"
				preset="HIGH_EMPHASIS"
				size="md"
				[loading]="loading"
				label="Continue"
			></ui-button>
		</div>
	</form>
</div>
